export default class InvalidResponseException extends Error {
  public constructor(message?: string) {
    super(message ?? 'Os dados retornados são inválidos!');
    this.name = 'InvalidResponseException';
  }
}
